/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { batchCreateContactsResponseDtoSchema } from "../batchCreateContactsResponseDtoSchema";
import { createContactsBatchDtoSchema } from "../createContactsBatchDtoSchema";
import { z } from "zod/v4";

export const createContactsBatchHeaderParamsSchema = z.object({
    "x-tenant-id": z.optional(z.string().describe("Required tenant context header for tenant-scoped endpoints guarded by ApiGuard."))
    }).optional()

/**
 * @description Batch-creates up to 100 contacts. Each contact is created independently, so one invalid item does not block or roll back the others. Pass dryRun: true to preview the results without persisting anything, or monitor: true to start monitoring every created contact.
 */
export const createContactsBatch201Schema = z.lazy(() => batchCreateContactsResponseDtoSchema)

/**
 * @description Missing tenant context or invalid x-api-key header for guarded endpoints.
 */
export const createContactsBatch401Schema = z.any()

export const createContactsBatchMutationRequestSchema = z.lazy(() => createContactsBatchDtoSchema)

export const createContactsBatchMutationResponseSchema = z.lazy(() => createContactsBatch201Schema)